
import { OtherDocumentRepository } from "../domain/OtherDocumentRepository"
import { VueOtherDocumentLoaderScreenData } from "../infra/VueOtherDocumentLoaderScreenData"

export class OtherDocLoaderComponent {
    
    document_repo:OtherDocumentRepository
    screen_data: VueOtherDocumentLoaderScreenData

    constructor(document_repo:OtherDocumentRepository, screen_data: VueOtherDocumentLoaderScreenData){
        this.document_repo = document_repo
        this.screen_data = screen_data
    }

    async fetchDocTypes() {
        return await this.document_repo.getAvailableTypes()
    }

    async mount(company_id) {
        let types = await this.fetchDocTypes()
        this.screen_data.setAvailableTypes(types)
        this.screen_data.setObtainedTypes(types)
        await this.getCompanyFolders(company_id)
    }

    async saveDocTypes() {
        this.screen_data.loadingSave = true
        await this.document_repo.saveDocumentTypes(this.screen_data.availableTypes)
        let new_types = await this.fetchDocTypes()
        new_types.push("add_type")
        this.screen_data.setAvailableTypes(new_types)
        this.screen_data.setObtainedTypes(new_types)
        this.screen_data.loadingSave = false
        this.screen_data.docTypesDialog = false
    }

    cancelSaveDocType() {
        this.screen_data.docTypesDialog = false
        let all_types = this.screen_data.obtainedTypes
        all_types.push("add_type")
        this.screen_data.setAvailableTypes(all_types)
    }

    addDocType() {
        let types = [...this.screen_data.availableTypes, '']
        this.screen_data.setAvailableTypes(types)
    }

    async moveDocsToAFolder(folder_uuid, doc_ids){
        const args = { folder_uuid, doc_ids }
        await this.document_repo.moveDocsToFolder(args)
    }

    async getCompanyFolders(company_id) {
        let args = { company_id }
        let folder_map =  await this.document_repo.getCompanyFolders(args)
        this.screen_data.companyFolders = [{'name':'Mi unidad','id':'Mi unidad', 'children': folder_map}]
    }

    async getAvailableCredits() {
        this.screen_data.saldo = await this.document_repo.getAvailableCredits()
    }
}